// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const join: MarkdocFunctionSchema = {
  render(parameters): string {
    const list = parameters['0'];
    const delimiter = parameters['1'] ?? '';

    return typeof list === 'object' && list.length
      ? list.join(delimiter)
      : list;
  },
};
